export default __webpack_public_path__ + "static/media/4.3d1b6b87.jpg";